import { collectListApi } from '@/api/my/collect'
// initial state
const state = {
  collectList: {}
}

// getters
const getters = {}

// actions
const actions = {
  // 收藏列表
  collectListAction ({ commit }) {
    return new Promise((resolve, reject) => {
      collectListApi().then(response => {
        if (response.status === '2000') {
          commit('setCollectList', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setCollectList (state, collectList) {
    state.collectList = collectList
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/my/collect.js